import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

interface NextStepCardProps {
  tasks: string[];
}

export const NextStepCard = ({ tasks }: NextStepCardProps) => {
  if (!tasks || tasks.length === 0) return null;

  return (
    <div className="bg-foreground text-background rounded-3xl p-6 shadow-xl mb-6">
      <h3 className="text-sm font-bold mb-4 opacity-90 uppercase tracking-wider">Tu Enfoque para Mañana</h3>
      
      <div className="space-y-3 mb-6">
        {tasks.map((task, i) => (
          <div key={i} className="flex items-start gap-3">
            <CheckCircle2 className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <p className="text-sm font-medium leading-relaxed">{task}</p>
          </div>
        ))}
      </div>

      <Link 
        to="/app/checkin" 
        className="w-full flex items-center justify-between p-4 rounded-xl bg-background text-foreground text-sm font-bold hover:bg-background/90 transition-colors"
      >
        Ir a Check-in <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
};
